import { WorkspaceSwitcher } from '@/features/support-session';
import { isPlatformAdmin, useAuth, WORKSPACE_KIND_PLATFORM } from '@/shared/auth';
import { cn } from '@/shared/lib/cn';

/**
 * In welchem Workspace arbeite ich gerade? Sichtbar, weil der interne Hauptadmin zwischen
 * Plattform- und Kunden-Workspaces unterscheiden muss und ein falscher Kontext sonst erst an
 * einem 403 auffällt. „Kunde wechseln“ bestimmt die eigene Anmeldung: nur der Plattform-Admin der
 * Plattform sieht es, auch während er in einer Support-Sitzung arbeitet.
 */
export function WorkspaceRow() {
  const { user, homeUser } = useAuth();
  if (!user?.workspaceName) return null;
  const support = Boolean(user.supportSessionId);
  return (
    <div
      className={cn(
        'rounded-control px-3 py-2',
        support ? 'bg-sealwax-tint border-sealwax/30 border' : 'border-line border border-dashed',
      )}
    >
      <p
        className={cn(
          'font-mono text-[10px] font-semibold uppercase tracking-[0.14em]',
          support ? 'text-sealwax' : 'text-ink-soft',
        )}
      >
        {support
          ? 'Support-Sitzung'
          : user.workspaceKind === WORKSPACE_KIND_PLATFORM
            ? 'Plattform-Workspace'
            : 'Workspace'}
      </p>
      <p className="text-ink truncate text-[13px] font-bold" title={user.workspaceName}>
        {user.workspaceName}
      </p>
      {isPlatformAdmin(homeUser) && <WorkspaceSwitcher />}
    </div>
  );
}
